import type { HttpClient } from '@remodeling/base';
import {
  GetApartRanksRequest,
  GetApartRanksResponse,
  GetShopConsultantRequest,
  GetShopConsultantResponse,
  GetShopDetailRequest,
  GetShopDetailResponse,
} from '../../model/dto';

// 매장 상세 API
export class GetShopDetailGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req?: GetShopDetailRequest) {
    return await this.httpClient.request<GetShopDetailResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/shop-service/api/v1/shops/${req?.shopId}?typeValue=${req?.typeValue}`,
    });
  }
}

// 최다 시공 아파트 목록 API
export class GetApartRanksGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetApartRanksRequest) {
    return await this.httpClient.request<GetApartRanksResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/shop-service/api/v1/shops/${req.shopId}/apart-ranks`,
    });
  }
}

// 전문 상담사 목록 API
export class GetShopConsultantGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetShopConsultantRequest) {
    return await this.httpClient.request<GetShopConsultantResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/shop-service/api/v1/shops/${req.shopId}/consultants?code=${req.code}`,
    });
  }
}
